import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  SimpleChanges,
  NgZone,
  Renderer2,
  ElementRef,
  ViewChild
} from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { OpenChatService } from 'src/app/services/OpenChat.service';
import { Subscription } from 'rxjs';
import {
  dummyStringContent,
  normalizeChatSearches,
} from 'src/app/guidGenerator';
import { OpenaiChatService } from 'src/app/services/openai-chat.service';
import { BaseApi } from 'src/backend/api/base-api';
import { LoggedUser } from 'src/backend/models/session-users/session-users';

interface ChatMessage {
  id: number;
  question: string;
  timestamp: Date;
}

@Component({
  selector: 'app-openai-chat',
  templateUrl: './openai-chat.component.html',
  styleUrls: ['./openai-chat.component.scss'],
})
export class OpenaiChatComponent implements OnInit {
  @ViewChild('iframeElement') iframeElement!: ElementRef<HTMLIFrameElement>;
  isNewChat: boolean = true;
  isSearchValue: boolean = false;
  isRequestInProgress: boolean = false;
  savedSearches: any[] = [];
  savedSearchesFromDB: any[] = [];
  localData: any[] = [];
  selectedChatId: number = 0;
  selectedChatData: any[] = [];
  isNewSearch: boolean = false;
  newSearchData!: any;
  searchCtrl = new FormControl();
  userImage: any;
  blobStorage = Constants.BLOB_STORAGE_URL;
  apiRequestSubscription: Subscription | null = null;
  currentChat: {
    id: number;
    title: any;
    date: Date;
    searchData: {
      id: number;
      searchTerm: any;
      responseContent: any;
      Type: any;
      chartType: any;
    }[];
  };
  userProfile: LoggedUser;
  recognition: any;
  isSpeaking: boolean = false;
  chatHistory: ChatMessage[] = [];

  @Input() chatWidth: string = '100%';
  @Input() isFullWidth: boolean;
  @Input() draggingWidth: boolean;
  @Input() token: string;
  @Input() Version: string;
  plantSession: any;
  userSession: LoggedUser;

  constructor(
    public openaiService: OpenaiChatService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private openChatService: OpenChatService,
    private cdr: ChangeDetectorRef,
    private baseApi: BaseApi,
    private ngZone: NgZone,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    // this.token = localStorage.getItem('auth_token');
  }

  ngOnInit() {
    console.log('isFullWidth getting', this.isFullWidth);
    console.log('Initial Chat Width:', this.chatWidth);

    this.plantSession = this.baseApi.getPlantFromStorage();
    this.userSession =  this.baseApi.getUserSession();

    this.getProfileInformation();
    this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
    this.chatSearchAdjustAutoHeight(false);
    this.hideSidePanel();

    const SpeechRecognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;

    if (!SpeechRecognition) {
      console.error('Speech Recognition is not supported in this browser.');
    } else {
      console.log('Speech Recognition is supported!');
    }
    // this.loadChatHistory();
    this.initializeSpeechRecognition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chatWidth']) {
      console.log('Chat Width changed:', changes['chatWidth'].currentValue);

      console.log('draggingWidth:', this.draggingWidth);

      console.log('isFullWidth:', this.isFullWidth);
    }
  }

  ngAfterViewInit() {
    if(this.Version== 'V2') {
    const iframeSrc = `https://multitable-app-app-nfjkjdp66bvbyojrkatjwa.streamlit.app?embed=true&embed_options=light_theme&usercode=${this.userSession?.userCode}&plantcode=${this.plantSession.plantCode}`;
    this.iframeElement.nativeElement.src = iframeSrc;
     this.loadChatHistory();
    }
    else{
    this.loadChatHistory();
    }
    //console.log('Iframe Source Set:', iframeSrc);
    //this.loadChatHistory();
  }

  //chat history

  saveChatHistory() {
    localStorage.setItem('chatHistory', JSON.stringify(this.chatHistory));
  }
  addToHistory(question: string) {
    const newMessage: ChatMessage = {
      id: Date.now(),
      question: question,
      timestamp: new Date(),
    };
    this.chatHistory.unshift(newMessage); // Add to beginning of array
    this.saveChatHistory();
  }

  loadChatHistory() {
    console.log('Loading chat history...');

    const savedHistory = localStorage.getItem('chatHistory');
    if (savedHistory) {
      this.chatHistory = JSON.parse(savedHistory).map((item: any) => ({
        ...item,
        timestamp: new Date(item.timestamp),
      }));
    }
  }

  clearHistory() {
    this.chatHistory = [];
    localStorage.removeItem('chatHistory');
  }

  // Add method to select history item
  selectHistoryItem(message: ChatMessage) {
    console.log('Selected history item:', message);

    this.searchCtrl.setValue(message.question);
    this.searchCtrl.markAsTouched();
    this.searchCtrl.markAsDirty();
    const textareaElement = this.el.nativeElement.querySelector('textarea');
    if (textareaElement) {
      this.renderer.setStyle(textareaElement, 'height', '92px');
      this.renderer.setStyle(textareaElement, 'overflow-y', 'auto');
    }
  }

  initializeSpeechRecognition() {
    const SpeechRecognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = false;
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;

      this.recognition.onresult = (event: any) => {
        const transcript = event.results[0][0].transcript;
        this.ngZone.run(() => {
          const currentText = this.searchCtrl.value || '';
          this.searchCtrl.setValue(currentText + transcript);
        });
      };

      this.recognition.onerror = (event: any) => {
        console.error('Speech recognition error', event);
      };

      this.recognition.onend = () => {
        console.log('Speech recognition ended');
      };
    } else {
      console.warn('Speech Recognition API is not supported in this browser.');
    }
  }

  startSpeechRecognition(): void {
    const SpeechRecognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;

    if (!SpeechRecognition) {
      this.toaster.warning(
        'Speech Recognition is not supported in this browser.'
      );
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      this.isSpeaking = true;
      console.log('Speech recognition started...');
    };

    recognition.onspeechend = () => {
      this.isSpeaking = false;
      console.log('Speech recognition ended.');
      recognition.stop();
    };

    // recognition.onresult = (event: any) => {
    //   const transcript = event.results[0][0].transcript;
    //   console.log('Recognized text:', transcript);
    //   if (transcript) {
    //     this.searchCtrl.setValue(this.searchCtrl.value + ' ' + transcript);
    //   }
    // };

    recognition.onresult = (event: any) => {
      const textarea = document.getElementById(
        'myTextArea'
      ) as HTMLTextAreaElement;
      const transcript = event.results[0][0]?.transcript;
      console.log('Recognized text:', transcript);

      if (transcript) {
        // Ensure the current value is not null or undefined
        const currentValue = this.searchCtrl.value || ''; // Fallback to an empty string if null/undefined
        const updatedValue = `${currentValue} ${transcript}`.trim(); // Trim any leading/trailing spaces
        this.searchCtrl.setValue(updatedValue); // Update the value
        this.searchCtrl.markAsTouched();
        this.searchCtrl.markAsDirty();
        const textareaElement = this.el.nativeElement.querySelector('textarea');
        if (textareaElement) {
          this.renderer.setStyle(textareaElement, 'height', '92px');
          this.renderer.setStyle(textareaElement, 'overflow-y', 'auto');
        }
      }
    };

    recognition.onerror = (event: any) => {
      this.isSpeaking = false;
      console.error('Speech recognition error:', event.error);
      // this.toaster.error('Speech recognition error: ' + event.error);
    };

    recognition.start();
  }

  // onExceedWidthChange(isExceedingWidth: boolean): void {
  //   console.log('isExceedingWidth1:', isExceedingWidth);

  //   this.isNarrow = isExceedingWidth;
  //   console.log(
  //     'isExceedingWidth:',
  //     isExceedingWidth,
  //     'isNarrow:',
  //     this.isNarrow
  //   );
  //   this.cdr.detectChanges();
  // }

  scrollContainer(): void {
    var scrollContainer = document.getElementById('scroll_area_container');
    if (scrollContainer === null) {
    } else {
      var scrollButton = document.getElementById('scroll_button');
      scrollContainer.scrollTop = scrollContainer?.scrollHeight;
      scrollContainer.addEventListener('scroll', function () {
        if (
          scrollContainer.clientHeight + scrollContainer.scrollTop <=
          scrollContainer.scrollHeight
        ) {
          scrollButton.style.visibility = 'visible';
        } else {
          scrollButton.style.visibility = 'hidden';
        }
      });
      scrollButton.addEventListener('click', function () {
        const scrollOptions: any = {
          top: scrollContainer.scrollHeight,
          behavior: 'smooth',
        };

        if ('scrollBehavior' in document.documentElement.style) {
          // Native smooth scrolling supported
          scrollContainer.scrollTo(scrollOptions);
        } else {
          // Polyfill for smooth scrolling
          smoothScrollTo(scrollContainer, scrollOptions.top, 1000); // Adjust the duration as needed
        }
      });
      // Polyfill for smooth scrolling
      function smoothScrollTo(element, target, duration) {
        var start = element.scrollTop,
          change = target - start,
          currentTime = 0,
          increment = 20;

        function animateScroll() {
          currentTime += increment;
          var val = easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;

          if (currentTime < duration) {
            setTimeout(animateScroll, increment);
          }
        }
        animateScroll();
      }
      // Easing function for smooth scrolling
      function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
    }
  }
  getProfileInformation() {
    // this.userProfile = this.baseApi.getUserSession();
    // if (this.userProfile?.picture) {
    //   this.userImage = this.blobStorage + this.userProfile.picture;
    // } else {
    //   this.userImage = 'assets/images/img_avatar.png';
    // }
    this.userProfile = this.baseApi.getUserSession();
    this.userImage = this.userProfile?.picture;
  }

  chatSearchAdjustAutoHeight(removeText: boolean): void {
    const textarea: any = document.getElementById('chat_search_textarea');
    const chatSearchIcon: any = document.querySelector('#chat_search_icon');
    textarea.value = textarea.value.trim();
    textarea.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
      if (textarea.value.trim()) {
        this.isSearchValue = true;
        if (chatSearchIcon) {
          chatSearchIcon.classList.add('search_icon_color');
        }
      } else {
        this.isSearchValue = false;
        if (chatSearchIcon) {
          chatSearchIcon.classList.remove('search_icon_color');
        }
      }
    });
    if (removeText) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      this.isSearchValue = false;
      if (chatSearchIcon) {
        chatSearchIcon.classList.remove('search_icon_color');
      }
    }
  }
  typeText(content: string, isEdit: boolean) {
    const contentElement = document.getElementById('new_search_content');
    const typingSpeed = 10; // Adjust the speed (in milliseconds) at which each character is typed
    let index = 0;
    // Replace newline characters with <br> tags
    content = content.replace(/\n/g, '<br>');
    const typing = () => {
      if (index < content.length) {
        const currentChar = content.charAt(index);
        if (currentChar === '<') {
          // Check if a "<br/>" tag is encountered
          const remainingContent = content.slice(index);
          if (remainingContent.startsWith('<br>')) {
            // Type the "<br/>" tag at once
            contentElement.innerHTML += '<br>';
            index += 5; // Skip the "<br/>" tag characters
          } else {
            contentElement.innerHTML += currentChar;
            index++;
          }
        } else {
          contentElement.innerHTML += currentChar;
          index++;
        }
        const lastChar = contentElement.innerHTML.charAt(
          contentElement.innerHTML.length - 1
        );
        if (
          lastChar === '\n' ||
          lastChar === '.' ||
          lastChar === ',' ||
          lastChar === '<br>'
        ) {
          this.scrollContainer();
        }
        setTimeout(typing, typingSpeed);
      } else {
        if (!isEdit) {
          this.savedSearchesFromDB.push({ ...this.newSearchData });
        }
        this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
        this.newSearchData.searchData[0].responseContent =
          this.newSearchData.searchData[0].responseContent.replace(
            /\n/g,
            '<br>'
          );

        this.selectedChatData.push({ ...this.newSearchData });
        this.isNewSearch = false;
        this.newSearchData = [];
        this.scrollContainer();
      }
    };
    typing();
  }
  closeChatModel(): void {
    const chatModel = document.querySelector('#openai_chat_model');
    if (chatModel) {
      chatModel.classList.remove('chat_show');
      chatModel.classList.add('chat_hide');
    }
    const body = document.querySelector('body');
    body.style.overflow = 'auto';
    setTimeout(() => {
      this.openaiService.destroyComponent();
    }, 300);
  }

  closeSidePanel(): void {
    const sidePanel = document.querySelector('#chat_side_panel');
    const mainContent = document.querySelector('#chat_main');
    const showButton: any = document.querySelector('.show_sidebar_button');
    if (sidePanel) {
      sidePanel.classList.remove('chat_side_bar_panel_show');
      sidePanel.classList.add('chat_side_bar_panel_close');
    }
    if (mainContent) {
      mainContent.classList.remove('chat_main_content_width');
      mainContent.classList.add('chat_main_content_fullwidth');
    }
    if (showButton) {
      showButton.style.visibility = 'visible';
    }
  }
  hideSidePanel(): void {
    const showButton: any = document.querySelector('.show_sidebar_button');
    const mainContent = document.querySelector('#chat_main');
    if (!this.isFullWidth) {
      mainContent.classList.add('chat_main_content_width');
      mainContent.classList.remove('chat_main_content_fullwidth');
      this.closeSidePanel();
      showButton.style.visibility = 'visible';
      return;
    }
  }
  showSidePanel(): void {
    const sidePanel = document.querySelector('#chat_side_panel');
    const showButton: any = document.querySelector('.show_sidebar_button');
    const mainContent = document.querySelector('#chat_main');
    if (!this.isFullWidth) {
      mainContent.classList.add('chat_main_content_width');
      mainContent.classList.remove('chat_main_content_fullwidth');
      this.closeSidePanel();
      return;
    }
    if (sidePanel) {
      sidePanel.classList.remove('chat_side_bar_panel_close');
      sidePanel.classList.add('chat_side_bar_panel_show');
    }
    if (mainContent) {
      mainContent.classList.add('chat_main_content_width');
      mainContent.classList.remove('chat_main_content_fullwidth');
    }
    if (showButton) {
      showButton.style.visibility = 'hidden';
    }
  }

  startNewChat(): void {
    this.isNewChat = true;
    this.selectedChatId = 0;
    this.selectedChatData = [];
  }

  onClickChat(data: any): void {
    this.selectedChatId = data?.id;
    this.isNewChat = false;
    this.selectedChatData = data?.searchData ? data?.searchData : [];
    this.newSearchData = data;
    // this.selectedChatData.push({ ...this.newSearchData });
    this.createChart(data, true);
    // setTimeout(() => {
    //   this.scrollContainer();
    // }, 300);
  }

  searchNewQuery(): any {
    if (this.searchCtrl.value.trim() === '') {
      alert('Please enter some text to search');
      return;
    }

    if (this.isRequestInProgress) {
      return;
    }
    this.isRequestInProgress = true;
    if (this.searchCtrl.value.trim() === '') {
      this.toaster.warning('Please enter some text to search', 'Warning');
      this.chatSearchAdjustAutoHeight(true);
      return;
    }
    this.addToHistory(this.searchCtrl.value.trim());
    let inputString = this.searchCtrl.value;
    let testDate = new Date();
    if (this.isNewChat && this.selectedChatId === 0) {
      // for new chat initialize calls for api will be make from here
      let obj = {
        query: this.searchCtrl.value.replace(/\n/g, ''),
        timeZoneHourDiff: Number(testDate.getTimezoneOffset() / 60),
      };
      this.searchCtrl.setValue('');
      // this.spinner.show();
      this.apiRequestSubscription = this.openChatService
        .askFromModel(obj)
        .subscribe(
          (data: any) => {
            const newChat = {
              id: Math.floor(Math.random() * 100000) + 1,
              title: inputString?.split(' ')?.slice(0, 6)?.join(' '),
              date: new Date(),
              searchData: [
                {
                  id: Date.now(),
                  searchTerm: inputString,
                  responseContent: data.agent_response,
                  Type: data.type || data.Type,
                  chartType: data?.chart_type,
                  module: data?.module,
                },
              ],
            };
            this.spinner.hide();
            this.isRequestInProgress = false;
            this.isNewChat = false;
            this.chatSearchAdjustAutoHeight(true);
            this.cdr.detectChanges();
            console.log('found2', { ...newChat });
            this.isNewSearch = true;
            this.selectedChatId = newChat.id;
            this.currentChat = newChat;
            this.newSearchData = { ...newChat };
            console.log('from second response');
            if (
              newChat.searchData[0].Type == 'chart' ||
              newChat.searchData[0].Type == 'bar' ||
              this.newSearchData?.searchData[0]?.Type == 'list' ||
              newChat.searchData[0].Type == 'chart/list'
            ) {
              this.createChart(
                this.newSearchData?.searchData[0]?.responseContent,
                false
              );
            } else {
              setTimeout(() => {
                this.typeText(
                  this.newSearchData?.searchData[0]?.responseContent.replace(
                    /\n/g,
                    '<br>'
                  ),
                  false
                );
              }, 300);
            }
          },
          (error: any) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
    }
    if (!this.isNewChat && this.selectedChatId > 0) {
      // for existing chat searches calls for api will be make from here
      const found = this.savedSearchesFromDB.find(
        (x) => x.id === this.selectedChatId
      );
      if (found) {
        let obj = {
          query: this.searchCtrl.value.replace(/\n/g, ''),
          timeZoneHourDiff: Number(testDate.getTimezoneOffset() / 60),
        };
        this.searchCtrl.setValue('');
        // this.spinner.show();
        this.apiRequestSubscription = this.openChatService
          .askFromModel(obj)
          .subscribe(
            (data: any) => {
              if ((data.type || data.Type) === 'Textual-Answer') {
                data.agent_response = data.agent_response.replace(
                  /\n/g,
                  '<br>'
                );
              }
              found.searchData.push({
                id: Date.now(),
                searchTerm: inputString,
                responseContent: data.agent_response,
                Type: data.type || data.Type,
                chartType: data?.chart_type,
                module: data?.module,
              });
              this.spinner.hide();
              this.isRequestInProgress = false;
              this.chatSearchAdjustAutoHeight(true);
              this.cdr.detectChanges();
              this.isNewSearch = true;
              this.currentChat = found;
              this.newSearchData = { ...found };
              if (
                this.newSearchData?.searchData[0]?.Type == 'chart' ||
                this.newSearchData?.searchData[0]?.Type == 'bar' ||
                this.newSearchData?.searchData[0]?.Type == 'list' ||
                this.newSearchData.searchData[0].Type == 'chart/list'
              ) {
                this.createChart(
                  this.newSearchData?.searchData[1]?.responseContent,
                  true
                );
              } else {
                setTimeout(() => {
                  const input = this.newSearchData?.searchData.find(
                    (x) => x.Type == 'Textual-Answer'
                  );
                  this.typeText(input.responseContent, true);
                }, 300);
              }
            },
            (error: any) => {
              this.spinner.hide();
              this.toaster.error('Error', error.message);
              this.isRequestInProgress = false;
            }
          );
      }
    }
  }

  stopGeneratingResponse(): void {
    if (this.apiRequestSubscription) {
      this.apiRequestSubscription.unsubscribe();
      this.isRequestInProgress = false;
    }
  }

  createChart(content: string, isEdit: Boolean) {
    if (!isEdit) {
      this.savedSearchesFromDB.push({ ...this.newSearchData });
      this.selectedChatData = [];
    }
    this.savedSearches = normalizeChatSearches(this.savedSearchesFromDB);
    this.selectedChatData.push({ ...this.newSearchData });
    // this.localData.push({...this.newSearchData})
    // localStorage.setItem('chatData', JSON.stringify(this.localData));
    // console.log('local storage data',this.localData)
    this.isNewSearch = false;
    this.newSearchData = [];
    this.scrollContainer();
  }

  ngOnDestroy(): void {
    if (this.apiRequestSubscription) {
      this.apiRequestSubscription.unsubscribe();
    }
  }
}
